import React from 'react';
import PropTypes from 'prop-types';
import { IconWithText } from 'Components';
import classNames from 'classnames';
import './Popover.css';

/* eslint react/no-array-index-key: 0 */

const Popover = (props) => {
  const items = props.links.map((item, key) => (
    <React.Fragment key={key}>
      <IconWithText
        key={key}
        onClick={e => props.onClick(e, key)}
        icon={item.icon}
        text={item.title}
        textOrientation="after"
        textAlign="left"
      />
      {key !== props.links.length - 1 ? <br /> : undefined}
    </React.Fragment>
  ));

  const domRef = props.domRef ? { ref: props.domRef } : {};

  return (
    <div
      className={classNames('popover', `popover--${props.placement}`, props.className)}
      style={props.style}
      {...domRef}
    >
      <ul className="popover--padding">
        {items}
        {props.children}
      </ul>
    </div>
  );
};

Popover.propTypes = {
  domRef: PropTypes.shape({}),
  className: PropTypes.string,
  style: PropTypes.shape({}), // eslint-disable-line
  links: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.string,
  })),
  onClick: PropTypes.func,
  placement: PropTypes.oneOf([
    'bottom',
    'bottom-start',
    'bottom-end',
  ]),
  children: PropTypes.node,
};

Popover.defaultProps = {
  onClick: () => null,
  placement: 'bottom-end',
  links: [],
};

export default Popover;



// WEBPACK FOOTER //
// ./src/components/Popover/Popover.jsx